var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_493_196)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#007ECA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#007ECA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 24.08C25.24 24.08 24.56 24.38 24.04 24.85L16.91 20.7C16.96 20.47 17 20.24 17 20C17 19.76 16.96 19.53 16.91 19.3L23.96 15.19C24.5 15.69 25.21 16 26 16C27.66 16 29 14.66 29 13C29 11.34 27.66 10 26 10C24.34 10 23 11.34 23 13C23 13.24 23.04 13.47 23.09 13.7L16.04 17.81C15.5 17.31 14.79 17 14 17C12.34 17 11 18.34 11 20C11 21.66 12.34 23 14 23C14.79 23 15.5 22.69 16.04 22.19L23.16 26.35C23.11 26.56 23.08 26.78 23.08 27C23.08 28.61 24.39 29.92 26 29.92C27.61 29.92 28.92 28.61 28.92 27C28.92 25.39 27.61 24.08 26 24.08Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_493_196",
    x: -4,
    y: -4,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_493_196"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_493_196",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNewsIcon);
export default __webpack_public_path__ + "static/media/shareNewsIcon.55bd14420b0ee7ba8a2d74649e1716b1.svg";
export { ForwardRef as ReactComponent };